module.exports = __webpack_public_path__ + "static/favicon.a86d7c9c.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/favicon.ico
// module id = 300
// module chunks = 168707334958949